import { createReducer } from 'typesafe-actions';
import { FETCH_VARIANTS, RESET_VARIANTS } from './actions';
import { ViewsModels } from './types';

export const variantsError = createReducer<Error | null>(null)
  .handleAction([FETCH_VARIANTS.failure], (_, { payload }) => payload)
  .handleAction([FETCH_VARIANTS.request, FETCH_VARIANTS.success, RESET_VARIANTS], () => null);

export const variantsLoading = createReducer<boolean | null>(false)
  .handleAction([FETCH_VARIANTS.request], () => true)
  .handleAction(
    [FETCH_VARIANTS.success, FETCH_VARIANTS.failure, FETCH_VARIANTS.cancel, RESET_VARIANTS],
    () => false,
  );

export const variants = createReducer<ViewsModels.VariantsModel | null>(null)
  .handleAction([FETCH_VARIANTS.failure, FETCH_VARIANTS.cancel, RESET_VARIANTS], () => null)
  .handleAction(FETCH_VARIANTS.success, (_, { payload }) => payload);
